import { render, staticRenderFns } from "./Overwatch.vue?vue&type=template&id=4ed41e2e&"
import script from "./Overwatch.vue?vue&type=script&lang=js&"
export * from "./Overwatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports